export default function CTASection() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="rounded-2xl overflow-hidden mb-10">
          <img
            src="https://readdy.ai/api/search-image?query=Minimalist%20warm%20beige%20shopping%20concept%20with%20elegant%20product%20arrangement%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20photography%2C%20sophisticated%20lifestyle%20aesthetic%2C%20neutral%20tones%2C%20gentle%20textures%2C%20modern%20European%20design%20feel&width=1200&height=600&seq=cta-section-image&orientation=landscape"
            alt="YOYBUY shopping experience"
            className="w-full h-auto object-cover rounded-2xl"
          />
        </div>

        <div className="text-center">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-3">
            Начните покупать через
          </h2>
          <p className="font-heading text-3xl md:text-4xl lg:text-5xl italic text-foreground-400 leading-tight mb-8">
            spreadsheet уже сегодня
          </p>

          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-2 px-10 py-4 rounded-full bg-foreground-950 text-background-50 font-semibold text-base hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-rocket-2-line text-lg"></i>
            Получить доступ сейчас
          </a>
        </div>
      </div>
    </section>
  );
}